export const getSearchIndexName = (name: string, locale?: string) => {
  if (locale) {
    return `${name}_${locale}`;
  }

  return name;
};
